var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudHomePage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 41.5C83.5 30.4935 79.1277 19.9378 71.3449 12.1551C63.5622 4.37231 53.0065 8.30967e-07 42 0C30.9935 -8.30966e-07 20.4378 4.37231 12.6551 12.1551C4.87231 19.9378 0.500002 30.4935 0.5 41.5H2.16C2.16 30.9338 6.35742 20.8003 13.8289 13.3289C21.3003 5.85741 31.4338 1.66 42 1.66C52.5662 1.66 62.6997 5.85742 70.1711 13.3289C77.6426 20.8003 81.84 30.9338 81.84 41.5H83.5Z",
    fill: "url(#paint0_linear_6105_81469)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4997 29.167C37.9925 29.167 35.0318 31.5232 34.1214 34.7419C33.9388 35.3878 33.3493 35.8337 32.6781 35.8337H32.333C29.0193 35.8337 26.333 38.52 26.333 41.8337C26.333 45.1474 29.0193 47.8337 32.333 47.8337H34.833C35.6614 47.8337 36.333 48.5052 36.333 49.3337C36.333 50.1621 35.6614 50.8337 34.833 50.8337H32.333C27.3624 50.8337 23.333 46.8042 23.333 41.8337C23.333 37.1109 26.9706 33.2378 31.5969 32.8633C33.1716 28.9394 37.0102 26.167 41.4997 26.167C45.9891 26.167 49.8277 28.9394 51.4025 32.8633C56.0287 33.2378 59.6663 37.1109 59.6663 41.8337C59.6663 46.8042 55.6369 50.8337 50.6663 50.8337H48.1663C47.3379 50.8337 46.6663 50.1621 46.6663 49.3337C46.6663 48.5052 47.3379 47.8337 48.1663 47.8337H50.6663C53.98 47.8337 56.6663 45.1474 56.6663 41.8337C56.6663 38.52 53.98 35.8337 50.6663 35.8337H50.3213C49.6501 35.8337 49.0606 35.3878 48.8779 34.7419C47.9675 31.5232 45.0068 29.167 41.4997 29.167Z",
    fill: "url(#paint1_linear_6105_81469)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4397 35.7723C41.0255 35.1866 41.9752 35.1866 42.561 35.7723L48.3943 41.6057C48.9801 42.1915 48.9801 43.1412 48.3943 43.727C47.8085 44.3128 46.8588 44.3128 46.273 43.727L43.0003 40.4543V53.4997C43.0003 54.3281 42.3288 54.9997 41.5003 54.9997C40.6719 54.9997 40.0003 54.3281 40.0003 53.4997V40.4543L36.7277 43.727C36.1419 44.3128 35.1921 44.3128 34.6063 43.727C34.0205 43.1412 34.0205 42.1915 34.6063 41.6057L40.4397 35.7723Z",
    fill: "url(#paint2_linear_6105_81469)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6105_81469",
    x1: 0.5,
    y1: 41.5,
    x2: 83.5,
    y2: 41.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F45FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6365"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6105_81469",
    x1: 23.333,
    y1: 38.5003,
    x2: 59.6663,
    y2: 38.5003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F45FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6365"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6105_81469",
    x1: 34.167,
    y1: 45.1663,
    x2: 48.8337,
    y2: 45.1663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F45FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6365"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudHomePage);
export default __webpack_public_path__ + "static/media/cloudHomePage.e3d3373f.svg";
export { ForwardRef as ReactComponent };